import './vehiculos.css';

export default function AdjuntosList({ items = [], onRemove }) {
  if (!items.length) {
    return <p className="table-empty">No hay adjuntos registrados.</p>;
  }

  return (
    <div className="adjuntos-list">
      {items.map((item, index) => (
        <div className="adjuntos-list__item" key={`${item}-${index}`}>
          <span>{item}</span>
          {typeof onRemove === 'function' && (
            <button type="button" onClick={() => onRemove(item)} aria-label={`Quitar adjunto ${item}`}>
              Quitar
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
